<template>
	<ValidationProvider name="voucher_uuid" rules="" v-slot="{ errors, valid }">
		<v-card flat>
			<v-card-title primary-title :class="{ 'red--text': !valid }">
				{{ $t("title.voucher") }}
				<v-icon right color="red" v-if="!valid">mdi-alert</v-icon>
			</v-card-title>
			<v-card-text>
				<v-slide-group show-arrows v-model="item.voucher_uuid">
					<v-slide-item
						v-for="(voucher, index) in vouchers"
						:key="index"
						v-slot="{ active, toggle }"
						:value="voucher.uuid"
					>
						<v-card
							@click="toggle"
							:color="active ? 'secondary white--text' : null"
							:input-value="active"
							width="200"
							class="ma-2"
							:dark="active"
						>
							<v-card-title primary-title>
								<v-icon left>mdi-sale</v-icon>
								{{ voucher.discount }}
							</v-card-title>
							<v-card-subtitle>
								{{ voucher.membership_name }}
							</v-card-subtitle>
						</v-card>
					</v-slide-item>
				</v-slide-group>
			</v-card-text>
		</v-card>
	</ValidationProvider>
</template>

<script>
export default {
	props: ["value", "vouchers"],
	computed: {
		item: {
			get() {
				return this.value;
			},
			set(value) {
				this.$emit("input", value);
			},
		},
	},
};
</script>